/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="94.95"
        height="95.4"
        viewBox="0 0 94.95 95.4"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M9.94 9.92a33.94 33.94 0 1 0 48.39.4l-.39-.4a34 34 0 0 0-48 0Zm46.23 1.77a31.18 31.18 0 1 1-.37-.37Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M9.94 9.92a33.94 33.94 0 1 0 48.39.4l-.39-.4a34 34 0 0 0-48 0Zm46.23 1.77a31.18 31.18 0 1 1-.37-.37Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M32.57 6.71a27.24 27.24 0 0 1 28.58 25.84A1.28 1.28 0 0 1 60 33.87a1.25 1.25 0 0 1-1.31-1.19 24.75 24.75 0 0 0-45.55-12.2A1.26 1.26 0 0 1 11 19.15 27.19 27.19 0 0 1 32.57 6.71Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="m67.21 59.53-8.14 8.14a1.26 1.26 0 0 0 0 1.76l25.61 25.61a1.25 1.25 0 0 0 1.77 0l8.13-8.13a1.25 1.25 0 0 0 0-1.77L69 59.53a1.26 1.26 0 0 0-1.79 0Zm.88 2.66 23.84 23.83-6.37 6.37-23.83-23.84Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="m57.29 57.75 6.26 6.26"/>
        <path
          fill="#fff"
          d="m59.77 55.28 6.25 6.25-5 4.95-6.25-6.25Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'MagnifyingGlassIcon';

export default Icon;
